import React from 'react';

class NewsPage extends React.Component {

    componentDidMount() {
        document.title = "Новости";
    }

    render() {
        return(
            <div className="news-page"><h1 className="news-page__title">Новости</h1>
                <div className="news-page__subtitle">Мы публикуем самое интересное и полезное</div>
                <div className="news-page__news-block">
                    <div className="news-page__news-item" id="news1">
                        <div className="news-page__img-block"><img className="news-page__img" src="images/bonch2.jpg"
                                                                   alt="" role="presentation"/></div>
                        <div className="news-page__text-block">
                            <div className="news-page__underscore"></div>
                            <h3 className="news-page__news-title">Bonch HackDay</h3>
                            <div className="news-page__stat">
                                <div className="news-page__views">
                                    <div className="news-page__date">14.03.18</div>
                                    <i className="fa fa-eye eye"></i><span className="news-page__view">0</span></div>
                                <div className="news-page__social">
                                    <div className="news-page__soc-link"><a className="news-page__soc-link-fb"
                                                                            href="http://www.facebook.com"><img
                                        className="news-page__soc-img-fb" src="images/facebook.png" alt=""
                                        role="presentation"/></a></div>
                                    <div className="news-page__soc-link"><a className="news-page__soc-link-ok"
                                                                            href="http://www.ok.ru"><img
                                        className="news-page__soc-img-ok" src="images/ok.png" alt=""
                                        role="presentation"/></a></div>
                                    <div className="news-page__soc-link"><a className="news-page__soc-link-vk"
                                                                            href="http://www.vk.com"><img
                                        className="news-page__soc-img-fb" src="images/vk.png" alt=""
                                        role="presentation"/></a></div>
                                    <div className="news-page__soc-link"><a className="news-page__soc-link-tw"
                                                                            href="http://www.twitter.com"><img
                                        className="news-page__soc-img-fb" src="images/tw.png" alt=""
                                        role="presentation"/></a></div>
                                    <a className="news-page__share" href="#">Поделиться новостью</a></div>
                            </div>
                            <div className="news-page__text-container"><p>АО «Заубер Банк», ООО «Системы информации и
                                связи» и ООО «Виз Софтвэр Консалтинг» приглашают студентов принять участие в хакатоне,
                                посвящённом современным перспективным технологиям. Мероприятие пройдёт на территории
                                Санкт-Петербургского государственного университета телекоммуникаций им. проф.
                                М.А.Бонч-Бруевича 23-25 марта 2018 года и будет состоять из трёх направлений:1. Интернет
                                вещей и искусственная реальность.
                                2. Искусственный интеллект и машинное обучение.
                                3. Технологии обработки данных.

                                На 48 часов мы закроем целый этаж здания университета, обеспечим вас интернетом, едой и
                                напитками (за исключением спиртных). Слабовольные получат подушки и пуфики на ночь. К
                                окончанию хакатона вы покажете и расскажете, чего вам удалось добиться.

                                ЧТО НУЖНО ДЛЯ УЧАСТИЯ?

                                Зарегистрироваться на сайте хакатона до 18 марта включительно. Вы можете прийти один или
                                с уже готовой командой. Участникам будут предложены задачи от организаторов, однако,
                                если у вас есть свои идеи и своё видение этих направлений, мы будем рады включить их в
                                соревнование.

                                ПРИЗЫ

                                Среди всех дошедших до финала участников будут разыграны подарки: iPhone X, iPhone 8,
                                iPad Pro 10,5 и ещё несколько приятных сюрпризов. Победители каждой секции получат
                                гаратированные призы. Некоторым из вас мы, возможно, предложим работу.
                                Секцию интернет вещей курирует компания STMicroelectronics. Это европейская (с
                                штаб-квартирой в Швейцарии) микроэлектронная компания, занимающихся разработкой,
                                изготовлением и продажей различных полупроводниковых электронных и микроэлектронных
                                компонентов. Вы можете сами попробовать догадаться, что они вам приготовили.
                                Приз в секции за машинное обучение — платформа для распределённых вычислений на основе
                                GPU NVIDIA P106-100 (даже если вы разочаруетесь в нейросетях, вы сможете использовать её
                                как майнер и обогреватель студенческого общежития).
                                Поскольку в секции обработки данных мы намерены затронуть темы блокчейна и криптовалют,
                                мы решили, что будет уместно подарить 3 ETH команде-победителю.
                                Небольшой криптовалютный перекос в призах не означает, что мы на них концентрируемся. Вы
                                можете заниматься анализом музыкальных произведений, изобретением инструментов
                                дополненной реальности, анализом исторических погодных данных и т.д.

                                И САМОЕ ГЛАВНОЕ

                                Как и в любом деле, в хакатоне самое главное — получать удовольствие от того, что вы
                                делаете.</p></div>
                        </div>
                    </div>
                    <div className="news-page__news-item" id="news2">
                        <div className="news-page__img-block"><img className="news-page__img"
                                                                   src="images/korporativ.jpg" alt=""
                                                                   role="presentation"/></div>
                        <div className="news-page__text-block">
                            <div className="news-page__underscore"></div>
                            <h3 className="news-page__news-title">Корпоратив</h3>
                            <div className="news-page__stat">
                                <div className="news-page__views">
                                    <div className="news-page__date">21.12.17</div>
                                    <i className="fa fa-eye eye"></i><span className="news-page__view">0</span></div>
                                <div className="news-page__social">
                                    <div className="news-page__soc-link"><a className="news-page__soc-link-fb"
                                                                            href="http://www.facebook.com"><img
                                        className="news-page__soc-img-fb" src="images/facebook.png" alt=""
                                        role="presentation"/></a></div>
                                    <div className="news-page__soc-link"><a className="news-page__soc-link-ok"
                                                                            href="http://www.ok.ru"><img
                                        className="news-page__soc-img-ok" src="images/ok.png" alt=""
                                        role="presentation"/></a></div>
                                    <div className="news-page__soc-link"><a className="news-page__soc-link-vk"
                                                                            href="http://www.vk.com"><img
                                        className="news-page__soc-img-fb" src="images/vk.png" alt=""
                                        role="presentation"/></a></div>
                                    <div className="news-page__soc-link"><a className="news-page__soc-link-tw"
                                                                            href="http://www.twitter.com"><img
                                        className="news-page__soc-img-fb" src="images/tw.png" alt=""
                                        role="presentation"/></a></div>
                                    <a className="news-page__share" href="#">Поделиться новостью</a></div>
                            </div>
                            <div className="news-page__text-container"><p>Корпоратив - это обычно когда все собираются
                                вместе, говорят, как много всяческих достижений они все вместе уже достигли, как много
                                достигают прямо сейчас и как много ещё достигнут - только дай время. Корпоратив - это
                                когда все благодарят организацию за то, что им предоставился шанс в ней поработать и
                                клянутся, что в новом году удалят профиль на hh.ru и сотрут резюме. Также на
                                корпоративах принято лебезить перед начальством. Но я зря надеялся.У нас все собрались
                                просто вместе приготовить еды и её тут же сожрать без лишних поучений.
                                Ничто так не объединяет как хруст совместно пережёвываемой новогодней пищи.

                                Вот прям даже жалко людей, которые работают не в нашей компании.</p></div>
                        </div>
                    </div>
                    <div className="news-page__news-item" id="news3">
                        <div className="news-page__img-block"><img className="news-page__img"
                                                                   src="images/export_day.jpg" alt=""
                                                                   role="presentation"/></div>
                        <div className="news-page__text-block">
                            <div className="news-page__underscore"></div>
                            <h3 className="news-page__news-title">День экспорта: цифровая экономика</h3>
                            <div className="news-page__stat">
                                <div className="news-page__views">
                                    <div className="news-page__date">13.12.17</div>
                                    <i className="fa fa-eye eye"></i><span className="news-page__view">0</span></div>
                                <div className="news-page__social">
                                    <div className="news-page__soc-link"><a className="news-page__soc-link-fb"
                                                                            href="http://www.facebook.com"><img
                                        className="news-page__soc-img-fb" src="images/facebook.png" alt=""
                                        role="presentation"/></a></div>
                                    <div className="news-page__soc-link"><a className="news-page__soc-link-ok"
                                                                            href="http://www.ok.ru"><img
                                        className="news-page__soc-img-ok" src="images/ok.png" alt=""
                                        role="presentation"/></a></div>
                                    <div className="news-page__soc-link"><a className="news-page__soc-link-vk"
                                                                            href="http://www.vk.com"><img
                                        className="news-page__soc-img-fb" src="images/vk.png" alt=""
                                        role="presentation"/></a></div>
                                    <div className="news-page__soc-link"><a className="news-page__soc-link-tw"
                                                                            href="http://www.twitter.com"><img
                                        className="news-page__soc-img-fb" src="images/tw.png" alt=""
                                        role="presentation"/></a></div>
                                    <a className="news-page__share" href="#">Поделиться новостью</a></div>
                            </div>
                            <div className="news-page__text-container"><p>Компания "Системы информации и связи" и
                                "Заубер Банк" приняли участие в конференции "День экспорта: цифровая экономика",
                                организованной Региональным Интегрированным Центром - Санкт-Петербург и Комитетом по
                                развитию предпринимательства и потребительского рынка Санкт-Петербурга на площадке
                                Санкт-Петербургской торгово-промышленной палаты. Мы выступали в секции "Цифровая
                                Экономика: как это работает?" (и работает ли вообще) со столь полюбившимися уже
                                футурологическими тезисами о блочейнах и криптографии. Еле ноги унесли.</p></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default NewsPage;


// WEBPACK FOOTER //
// ./src/Components/News/NewsPage.js